import { render, staticRenderFns } from "./ProductSaleTracking.vue?vue&type=template&id=25428855"
import script from "./ProductSaleTracking.vue?vue&type=script&lang=js"
export * from "./ProductSaleTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports